<template>
  <div class="mt-16 bg-white bg-opacity-60 min-h-screen">
    <div class="flex items-center justify-start bg-beige-academy-300 w-full py-2
      text-white text-left">
      <div class="text-lg w-full px-5 md:px-8 font-sans-serif flex">
        <router-link class="pr-2" to="/teacher-dashboard/classrooms">{{$t('classrooms.classrooms')}}
        </router-link>
        / <span class="pl-2"> {{ $t('media.media')}} </span>
      </div>
    </div>
    <div class="flex flex-col w-11/12 lg:w-3/4 justify-center items-center mt-10 mx-auto">
      <h1 class="text-2xl text-center justify-self-center self-center w-full uppercase">
        {{ $t('media.title')}}
      </h1>
      <h2 class="font-sans-serif pt-4">{{ $t('media.formats')}}</h2>
      <h2 class="font-sans-serif">{{ $t('media.size')}}</h2>
    </div>

    <div class="flex flex-col lg:flex-row justify-between w-full lg:w-3/4 mx-auto py-10
    items-start text-center">
      <div class="w-full lg:w-1/2 pb-6 block lg:hidden">
        <button class="font-sans-serif bg-orange-academy-100 text-white p-4 shadow-lg rounded-lg
          text-xl" @click="$modal.show('media-uploader')">
          {{ $t('media.upload')}}
        </button>
      </div>
      <media-list :media="media" :editing="true" @delete="deleteMedia($event)" />
      <div class="w-full lg:w-1/2 pt-20 hidden lg:block">
        <button class="font-sans-serif bg-orange-academy-100 text-white p-4 shadow-lg rounded-lg
          text-xl" @click="$modal.show('media-uploader')">
          {{ $t('media.upload')}}
        </button>
      </div>
    </div>

    <modal resizable name="media-uploader" height="auto" :adaptive="true">
      <media-uploader class="w-full"
        :id="user.teacher.id" @media-uploaded="getMedia" />
    </modal>

    <modal resizable name="cannot-delete" height="auto" :adaptive="true">
      <cannot-delete
        @close="$modal.hide('cannot-delete')"
        :sentence="$t('media.cannotDelete')" />
    </modal>

    <modal resizable name="sure-to-delete" height="auto" :adaptive="true">
      <are-you-sure-to-delete
        @delete="sureDeleteMedia"
        @close="$modal.hide('sure-to-delete')"
        v-if="mediaToDelete"
        :question="$t('media.delete')+mediaToDelete.description+'?'"
        :isLoading="isLoading" />
    </modal>

  </div>
</template>

<script>
import { getTeacherMedia } from '@/services/TeacherService';
import { mapGetters } from 'vuex';
import MediaList from '@/components/teachers/MediaList.vue';
import MediaUploader from '@/components/fileUpload/MediaUploader.vue';
import axios from 'axios';
import CannotDelete from '../components/modals/CannotDelete.vue';
import AreYouSureToDelete from '../components/modals/AreYouSureToDelete.vue';

export default {
  components: {
    MediaList,
    MediaUploader,
    CannotDelete,
    AreYouSureToDelete,
  },

  data() {
    return {
      media: [],

      mediaToDelete: null,

      isLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },

  created() {
    this.getMedia();
  },

  methods: {
    getMedia() {
      getTeacherMedia(this.user.teacher.id).then(({ data }) => {
        this.media = [];
        this.media = data;
      });
    },

    deleteMedia(media) {
      if (media.hasTemplates) {
        this.$modal.show('cannot-delete');
        return;
      }
      this.mediaToDelete = media;
      this.$modal.show('sure-to-delete');
    },

    sureDeleteMedia() {
      this.isLoading = true;
      axios.delete(`/api/media/${this.mediaToDelete.id}`).then(() => {
        this.$modal.hide('sure-to-delete');
        this.isLoading = false;
        this.getMedia();
      });
    },

  },
};
</script>
